module.exports = __webpack_public_path__ + "static/media/5.question.23a528d3.mp4";